import React, { useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useCart } from '../context/CartContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import '../styles/FirstDay.css';

// Define default prices for each tier
const tierPrices = {
    basic: 999,
    signature: 1499,
    luxury: 3499,
};
const tierImageMap = {
    basic: 'https://www.foodies.pk/wp-content/uploads/2019/07/basic-free-package.png',
    signature: 'https://cdn5.vectorstock.com/i/1000x1000/90/29/vip-member-premium-user-icon-on-white-vector-34649029.jpg',
    luxury: 'https://media.istockphoto.com/id/1172210091/vector/diamond-line-icon-editable-stroke-pixel-perfect-for-mobile-and-web.jpg?s=612x612&w=0&k=20&c=fBTrpqRguqTxtcMdJ_7nTT16-zVtbDRmtX0XVeZSypg=',
};

export default function CartPage() {
    const { cartItems, removeFromCart, clearCart } = useCart();
    const navigate = useNavigate();
    const location = useLocation();
    const fromTier = location.state?.selectedTier;

    // Calculate costs: include tier and any additional items
    const tierKey = fromTier ? fromTier.toLowerCase() : null;
    const tierCost = tierKey && tierPrices[tierKey] ? tierPrices[tierKey] : 0;
    const additionalCost = cartItems.reduce((sum, item) => sum + (item.cost || 0), 0);
    const totalCost = tierCost + additionalCost;

    return (
        <div className="container my-4">
            {/* Back Button: restore tier view or go back */}
            <Button
                variant="outline-secondary"
                size="sm"
                className="mb-3"
                onClick={() => navigate(-1)}
            >
                ← Back
            </Button>
            <h2>Cart</h2>

            {/* Default Tier Item */}
            {fromTier && (
                <Card className="custom-card mb-3" style={{ display: 'flex', alignItems: 'center', padding: '0.75rem' }}>
                    <div className="card-body-itinerary-item d-flex align-items-center" style={{ width: '100%' }}>
                        <div className="card-details flex-grow-1 d-flex align-items-center" style={{ lineHeight: 1.4 }}>
                            {/* Render tier image if exists */}
                            {fromTier && tierImageMap[tierKey] && (
                                <img
                                    src={tierImageMap[tierKey]}
                                    alt={`${fromTier} tier`}
                                    style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px', marginRight: '0.75rem' }}
                                />
                            )}
                            <div>
                                <div><strong>{fromTier ? `${fromTier.charAt(0).toUpperCase() + fromTier.slice(1)} Tier` : 'No Tier Selected'}</strong></div>
                                <div>📦 Package</div>
                                <div>💰 Estimated Cost: ${tierCost}</div>
                            </div>
                        </div>
                    </div>
                </Card>
            )}

            {/* Additional Cart Items */}
            {cartItems.length === 0 && !fromTier && <p>Your cart is empty.</p>}

            {cartItems.map(item => (
                <Card
                    key={item.place_id}
                    className="custom-card mb-3"
                    style={{ display: 'flex', alignItems: 'center', padding: '0.75rem' }}
                >
                    <div
                        className="card-body-itinerary-item d-flex align-items-center"
                        style={{ width: '100%' }}
                    >
                        {item.image && (
                            <div style={{ width: '4rem', textAlign: 'center', marginRight: '1.5rem' }}>
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    style={{
                                        width: '60px',
                                        height: '60px',
                                        objectFit: 'cover',
                                        borderRadius: '4px'
                                    }}
                                />
                            </div>
                        )}
                        <div className="card-details flex-grow-1" style={{ lineHeight: 1.4 }}>
                            <div><strong>{item.name}</strong></div>
                            <div>🏛️ {item.category || 'Activity'}</div>
                            <div>⏱️ Duration: {item.start_time} – {item.end_time}</div>
                            <div>💰 Estimated Cost: {item.cost ? `$${item.cost}` : 'Free'}</div>
                        </div>
                        <Button
                            variant="outline-danger"
                            size="sm"
                            style={{ marginLeft: 'auto', padding: '0.25rem 0.5rem' }}
                            onClick={() => removeFromCart(item.place_id)}
                            aria-label="remove from cart"
                        >
                            <FaTrash size={16} />
                        </Button>
                    </div>
                </Card>
            ))}

            {/* Summary & Actions */}
            {(fromTier || cartItems.length > 0) && (
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <h4>Total: ${totalCost}</h4>
                    <div>
                        <Button variant="secondary" className="me-2" onClick={clearCart}>
                            Clear Cart
                        </Button>
                        <Button variant="primary" onClick={() => navigate('/checkout', {
                            state: {
                                cartItems: cartItems,
                                selectedTier: fromTier,
                                tierCost: tierCost,
                                totalCost: totalCost
                            }
                        })}>
                            Checkout
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}
